import { useServiceError } from '@/hooks';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { generatePurchaseAbcCurve } from './Purchase.service';

export function useGeneratePurchaseAbcCurve() {
  const mutation = useMutation(generatePurchaseAbcCurve, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Relatório de Curva ABC gerado com sucesso!',
      });
    },
  });

  useServiceError(mutation.error);

  return mutation;
}
